import { configureStore } from '@reduxjs/toolkit';
import todoReducer from './sessionMgmnt';

export default configureStore({
    reducer: {
        sessionMgmnt: todoReducer
    },
});